<template>
    <div>
        <v-layout row wrap align-end
                  :class="{'px-3': $vuetify.breakpoint.xs}"
        >
            <v-flex lg6>
                <h1 class="section-title-main my-3 mr-4 font-weight-regular">{{$t("Новости и мероприятия")}}</h1>
            </v-flex>
            <v-flex sm12 lg6 :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
                <inputIcon
                  v-model="news_search"
                  icon_name="search"
                  :placeholder="$t('Поиск по разделу')"
                  class="layout row search--no-border"
                />
            </v-flex>
        </v-layout>
        <v-layout wrap align-center justify-space-between
                  :class="{'my-4': $vuetify.breakpoint.smAndDown, 'my-5': $vuetify.breakpoint.mdAndUp}"
        >
            <v-flex>
                <v-tabs
                    v-model="set_tab"
                    slot="extension"
                    color="white"
                    slider-color="#e2173d"
                    class="pr-4 tabs__bottom-border"
                >
                    <v-tab
                        v-for="(item, i) in tabs"
                        :key="i"
                        :href="'#'+item.type"
                        @click="items_for_use(item)"
                    >
                        {{ $t(item.tab_title) }}
                    </v-tab>
                </v-tabs>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.mdAndUp" class="text-md-right">
                <buttonBdWhite @click.native="show">{{ $t(button_value) }}</buttonBdWhite>
            </v-flex>
        </v-layout>
        <div v-if="show_filter" class="py-4" :class="{'mx-3': $vuetify.breakpoint.xs}">
            <!-- <v-layout class="mb-2" align-center>
                <v-flex>
                    <span class="grey-text">{{$t("Показать за период")}}</span>
                </v-flex>
            </v-layout> -->
            <v-layout class="wrap" align-center>
                <v-flex v-if="set_tab=='events'" class="news_filter-item" xs12
                        sm6 md3 :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <span class="grey-text">{{$t("Категория мероприятия")}}</span>
                    <v-select
                        :items="eventTypes"
                        solo
                        append-icon=""
                        :label="$t('Все')"
                        class="input mt-2"
                        :value = "filter_category"
                        @change="changeEventType($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex class="news_filter-item" sm12 md5
                        :class="{'pt-4': $vuetify.breakpoint.smAndDown}"
                >
                    <span class="grey-text">{{$t("Показать за период")}}</span>
                    <v-layout wrap>
                        <v-flex sm6 xs12>
                            <datepicker v-model="set_filter_from" ref="datafilter_from" :placeholder="filter_by_date.from ? get_date(filter_by_date.from) : get_date(new Date().getTime())"
                                        class="mt-2"
                            />
                        </v-flex>
                        <v-flex sm6 xs12>
                            <datepicker v-model="set_filter_to" ref="datafilter_to" :included="true"
                                        :placeholder="filter_by_date.to ? get_date(filter_by_date.to) : get_date(new Date().getTime())"
                                        class="mt-2"
                            />
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex class="news_filter-item icon-label-red label_news pt-3" xs12 sm6
                        md3 :class="{'ml-4': $vuetify.breakpoint.mdAndUp}"
                >
                    <a class="link" @click="reset">{{$t("Сбросить фильтр")}}</a>
                </v-flex>
            </v-layout>
        </div>
        <v-layout v-if="$vuetify.breakpoint.smAndDown" class="text-md-right pb-4" :class="{'mx-3': $vuetify.breakpoint.xs}">
            <buttonBdWhite :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="show">{{ $t(button_value) }}</buttonBdWhite>
        </v-layout>
        <v-tabs-items v-model="set_tab">
            <v-tab-item
                v-for="(i) in tabs"
                :value="i.type"
                :key="i.id"
                :href="`#tab-${i.id}`"
            >
                <v-card flat class="py-5">
                    <div v-if="i.type == 'all'">
                        <div v-if="news && !news.length" class="mt-4" :class="{'px-3 pb-5': $vuetify.breakpoint.xs}">{{$t("Ничего не найдено")}}</div>
                        <div v-for="(item) in news" :key="item.id">
                            <div class="news__wrap">
                                <news :label_class="label_class(item.type)" :content="item" />
                            </div>
                        </div>
                    </div>
                    <div v-if="i.type !== 'all'">
                        <div v-if="news && !news.length" class="mt-4" :class="{'px-3 pb-5': $vuetify.breakpoint.xs}">{{$t("Ничего не найдено")}}</div>
                        <div v-for="(item) in news" :key="item.id">
                            <div class="news__wrap">
                                <news :label_class="label_class(i.type)" :content="item" />
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
        <v-layout v-if="news && news.length" align-center justify-space-between
                  wrap class="my-4" :class="{'mx-3 pb-4': $vuetify.breakpoint.xs}"
        >
            <v-flex md4 sm6 xs12>
                <v-layout>
                    <buttonBdWhite :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="OPEN_MODAL('suggest_news_modal')">{{$t("Предложить новость / мероприятие")}} </buttonBdWhite>
                </v-layout>
            </v-flex>
            <v-flex v-if="news_pages > 1 || news.length > 9 " md4 sm6
                    xs12
                    :class="{'mt-4': $vuetify.breakpoint.xs}"
            >
                <div class="text-xs-center">
                    <v-pagination
                        v-model="page"
                        :length="news_pages"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 5"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex v-if="news_pages > 1 || news.length>9" md4 sm6
                    xs12
                    :class="{'mt-4': $vuetify.breakpoint.smAndDown}"
            >
                <v-select
                    v-model="listSize"
                    :items="$vuetify.breakpoint.mdAndUp ?
                      [
                        {
                          text: $t('Показывать по 10'),
                          value: 'Показывать по 10',
                        },
                        {
                          text: $t('Показывать по 25'),
                          value: 'Показывать по 25',
                        },
                        {
                          text: $t('Показывать по 50'),
                          value: 'Показывать по 50',
                        },
                        {
                          text: $t('Показывать по 100'),
                          value: 'Показывать по 100',
                        },
                      ]
                      :
                      [
                        {
                          text: $t('Показывать по 10'),
                          value: 'Показывать по 10',
                        },
                        {
                          text: $t('Показывать по 25'),
                          value: 'Показывать по 25',
                        },
                        {
                          text: $t('Показывать по 50'),
                          value: 'Показывать по 50',
                        },
                      ]"
                    solo
                    append-icon=""
                    class="input"
                    @change="pages($event)"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
        <v-dialog v-model="suggest_news_modal" persistent content-class="scrolled-dialog">
            <addNewsModal v-if="suggest_news_modal" />
        </v-dialog>
    </div>
</template>

<script>
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import {button_bd_white} from '@/components/ui/buttons/base_buttons.js';
import news from '@/components/blocks/news/news_page_item';
import darkLink from '@/components/ui/links/styled/link_dark';
import addNewsModal from './News_modals/modal_add_news';
import dayjs from 'dayjs';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import utc from 'dayjs-plugin-utc';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);
dayjs.extend(utc);

export default {
  components: {
    'buttonBdWhite': button_bd_white,
    news,
    datepicker,
    inputIcon,
    darkLink,
    addNewsModal,
  },
  data() {
    return {
      button_value: 'Показать фильтр',
      search      : '',
      clear       : false,
      show_filter : false,
      index       : 1,
      listSize: 'Показывать по 10',
    };
  },
  computed: {
    eventTypes() {
      return this.event_types.map((type) => ({
        ...type,
        text: this.$t(type.text),
        value: type.text,
      }))
    },
    ...mapGetters('news_offer', ['current_item']),
    ...mapGetters('news_main', [
      'event_types',
      'suggest_news_modal',
      'user_id',
      'news',
      'filter_by_date',
      'tabs',
      'type',
      'news_pages',
      'selected_page',
      'filter_by_search',
      'filtered_by_date',
      'search_by_string',
      'filter_category',
      'tab_model',
    ]),
    set_filter_from: {
      get() {
        return this.get_date(this.filter_by_date.from);
      },
      set($event) {
        let date_from = $event.target.value.slice(0, 10).split('.');
        date_from = new Date(date_from[2], date_from[1]-1, date_from[0]);
        const dates = {};
        dates.value = new dayjs(date_from).set('hour', 23).set('minutes', 59).unix();
        dates.period = 'from';
        this.SET_FILTER_DATES(dates);
        this.get_news();
        return true;
      },
    },
    set_filter_to: {
      get() {
        return this.get_date(this.filter_by_date.to);
      },
      set($event) {
        let date_to = $event.target.value.slice(0, 10).split('.');
        date_to = new Date(date_to[2], date_to[1]-1, date_to[0]);
        const dates = {};
        dates.value = new dayjs(date_to).set('hour', 23).set('minutes', 59).unix();
        dates.period = 'to';

        this.get_index(1);
        this.SET_FILTER_DATES(dates);
        this.get_news();
        return true;
      },
    },
    news_search: {
      get() {
        return this.search;
      },
      set($event) {
        this.search = $event.target.value;
        this.SEARCH_STRING($event.target.value);
        this.get_news();
      },
    },
    set_tab: {
      get() {
        return this.tab_model;
      },
      set($event) {
        this.SET_TAB($event);
        this.get_news();
        return true;
      },
    },
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        this.SET_SELECTED_PAGE($event);
        this.get_news();
        return true;
      },
    },
  },
  mounted() {
    this.get_news();
    this.get_index(1);
  },
  methods: {
    ...mapActions('news_main', [
      'get_news',
      'event_category',
    ]),
    ...mapActions('favourites', [
      'add_to_favourites',
      'remove_from_favourites',
    ]),
    ...mapMutations('news_offer', ['SET_CURRENT_ITEM']),
    ...mapMutations('news_main', [
      'SEARCH_STRING',
      'SET_NEWS_COUNT',
      'SET_NEWS_TYPE',
      'SET_FILTER_DATES',
      'RESET_FILTER',
      'OPEN_MODAL',
      'SET_TAB',
      'SET_SELECTED_PAGE',
    ]),
    reset() {
      this.RESET_FILTER();
      this.$refs.datafilter_from.clear_calendar();
      this.$refs.datafilter_to.clear_calendar();
      this.clear = true;
    },
    got_to_descript(id) {
      this.$router.push({name: 'news_descript', params: {id: id}});
    },
    show() {
      this.show_filter = !this.show_filter;
      if (this.show_filter) {
        this.button_value = 'Скрыть фильтр';
      } else {
        this.button_value = 'Показать фильтр';
      }
    },
    get_index(page) {
      this.index = page-1;
    },
    pages(nextSize) {
      this.SET_NEWS_COUNT({array: this.news, selected: nextSize});
      this.get_index(1);
      this.get_news();
    },
    changeEventType(nextType) {
      this.event_category(nextType);
    },
    items_for_use(item) {
      this.SET_NEWS_TYPE(item.type);
      //   this.SET_CURRENT_ITEM(item.type);
      this.get_index(1);
    },
    get_date(date) {
      return new dayjs(parseInt(date)).utc().format('DD.MM.YYYY');
    },
    get_time(date) {
      return new dayjs(parseInt(date)).utc().format('HH.mm');
    },
    label_class(type) {
      if (type == 'news') {
        return 'section-label--green';
      }
      if (type == 'events') {
        return 'section-label--grey';
      }
      if (type == 'actions') {
        return 'section-label--red';
      }
      // if (type == 'marketing') {
      //   return 'section-label--blue';
      // }
    },
  },
};
</script>
